import { Select } from "antd"
import useServiceTicketsEnabled from '../../../hooks/useServiceTicketsEnabled'
import VSpace from "../../common/VSpace"
import SettingsCard from "../SettingsCard"
import { useState } from "react"
import { ProposalSettings } from "../../../domain/proposals/settings/proposalSettings"
import RichTextEditor from "../../RichTextEditor/RichTextEditor"
import { useUpdateTermsAndConditionsMutation } from "../../../domain/proposals/settings/proposalSettingsQueries"

type Props = {
  proposalSettings: ProposalSettings
}

const TermsAndConditionsSettings = ({ proposalSettings }: Props) => {
  const showServiceTickets = useServiceTicketsEnabled()
  const [settings, setSettings] = useState<ProposalSettings>(proposalSettings)
  const [jobType, setJobType] = useState<string>('project')
  const updateTermsAndConditionsMutation = useUpdateTermsAndConditionsMutation()

  const getCurrentTerms = () => {
    switch (jobType) {
      case 'project':
        return settings.projectsTerms
      case 'maintenance':
        return settings.maintenanceTerms
      case 'service-ticket':
        return settings.serviceTicketsTerms
      default: 
      return ''
    }
  }

  const updateTerms = (terms: string) => {
    switch (jobType) {
      case 'project':
        setSettings({ ...settings, projectsTerms: terms })
        break
      case 'maintenance':
        setSettings({ ...settings, maintenanceTerms: terms })
        break
      case 'service-ticket':
        setSettings({ ...settings, serviceTicketsTerms: terms })
        break
    }
  }

  const isChanged = settings.projectsTerms !== proposalSettings.projectsTerms ||
    settings.maintenanceTerms !== proposalSettings.maintenanceTerms ||
    settings.serviceTicketsTerms !== proposalSettings.serviceTicketsTerms

  return <SettingsCard
    id="terms-and-conditions-card"
    title="Terms and Conditions"
    description="Add the terms and conditions that will appear on your proposals. These will be visible to clients before they accept."
    onUpdate={() => {
      updateTermsAndConditionsMutation.mutate({
        projectsTerms: settings.projectsTerms,
        maintenanceTerms: settings.maintenanceTerms,
        serviceTicketsTerms: settings.serviceTicketsTerms
      })
    }}
    isUpdating={updateTermsAndConditionsMutation.isLoading}
    updateDisabled={!isChanged}
  >
    <VSpace>
      <span>Job Type</span>
      <Select
        options={[
          {
            label: 'Project',
            value: 'project'
          },
          {
            label: 'Maintenance',
            value: 'maintenance'
          },
          ...(showServiceTickets ? [{
            label: 'Service Ticket',
            value: 'service-ticket'
          }] : [])
        ]}
        onChange={setJobType}
        value={jobType}
        popupMatchSelectWidth={false}
      />
      <RichTextEditor
        value={getCurrentTerms()}
        onChange={updateTerms}
      />
    </VSpace>
  </SettingsCard>
}

export default TermsAndConditionsSettings
